import React from "react"
import PropTypes from "prop-types"
//components
import { Link, graphql } from "gatsby"
import IndexLayout from "../components/IndexLayout"
import PostCard from "../components/postCard"

//utilities
import { rhythm } from "../utils/typography"
import styled from "styled-components"
import { themeMedia } from "../utils/theme"

//Styled components
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: auto;
  grid-gap: ${rhythm(1)};
  align-items: start;
  @media (max-width: ${themeMedia.maxMedium}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${themeMedia.maxXsmall}) {
    grid-template-columns: 1fr;
  }
`

const Tags = ({ pageContext, data, location }) => {
  const { tag } = pageContext
  const { edges, totalCount } = data.allMarkdownRemark
  const tagHeader = `${totalCount} article${
    totalCount === 1 ? "" : "s"
  } dans la catégorie "${tag}"`
  return (
    <IndexLayout location={location}>
      <h1>{tagHeader}</h1>
      <GridContainer>
        {edges.map(({ node }) => {
          return <PostCard data={node} key={node.fields.slug} />
        })}
      </GridContainer>
      {<Link to="/tags">All tags</Link>}
    </IndexLayout>
  )
}

Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired,
            }),
            fields: PropTypes.shape({
              slug: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}

export default Tags
export const pageQuery = graphql`
  query tagPageQuery($tag: String) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD/MM/YYYY")
            title
            description
            tags
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          timeToRead
        }
      }
    }
  }
`
